import queryString from "query-string";
import { api, authHeader } from "../configs/axiosConfigs";

const createApi = (base) => ({
  getPagedList: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetPagedList?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getDetail: async (id) => {
    const response = await api.request({
      url: `${base}/GetDetail?${queryString.stringify({ id })}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getWarehouses: async () => {
    const response = await api.request({
      url: `${base}/GetWarehouses`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getStockBalances: async (params = {}) => {
    const response = await api.request({
      url: `${base}/GetStockBalances?${queryString.stringify(params)}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  create: async (data) => {
    const response = await api.request({
      url: `${base}/Create`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  updateDraft: async (data) => {
    const response = await api.request({
      url: `${base}/UpdateDraft`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  markSent: async (data) => {
    const response = await api.request({
      url: `${base}/MarkSent`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  markReviewed: async (data) => {
    const response = await api.request({
      url: `${base}/MarkReviewed`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  confirmComplete: async (data) => {
    const response = await api.request({
      url: `${base}/ConfirmComplete`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  cancel: async (data) => {
    const response = await api.request({
      url: `${base}/Cancel`,
      method: "POST",
      data,
      headers: { ...authHeader(), "Content-Type": "application/json" },
    });
    return response.data;
  },

  downloadPdf: async (id) => {
    const response = await api.request({
      url: `${base}/DownloadPdf?${queryString.stringify({ id })}`,
      method: "GET",
      responseType: "blob",
      headers: authHeader(),
    });
    return response;
  },

  downloadHtml: async (id) => {
    const response = await api.request({
      url: `${base}/DownloadHtml?${queryString.stringify({ id })}`,
      method: "GET",
      responseType: "text",
      headers: authHeader(),
    });
    return response;
  },
});

const managementBase = "/SLN/Management/WarehouseSlip";
const operatorBase = "/SLN/SolarentOperator/WarehouseSlip";

export const warehouseSlipManagementApi = createApi(managementBase);
export const warehouseSlipOperatorApi = createApi(operatorBase);

export default warehouseSlipManagementApi;
